import { defaultHttpClient } from '../../httpClient';
import type { GetMarketCouponListResponse } from './types';

export const getMarketCouponList = (marketId: number) => {
  return defaultHttpClient
    .request<GetMarketCouponListResponse>({
      method: 'GET',
      url: `/api/v2/markets/${marketId}/coupons/`,
    })
    .then(result => result.data);
};
